import { FormControl, Validators } from '@angular/forms';
import { ValidatorsService } from '@core/Abstract/validators/validators.service';
import {
  AlphaNumericValidator, AlphaNumericAndSpecialCharsValidator, dateFutureValidator,
  currencyValidator, EmailValidator, NumericValidator, AsyncIbanValidator
} from '@core/Abstract/validators/validators';
import { TranslateService } from '@ngx-translate/core';

export function registerValidators(translate: TranslateService, validatorsService: ValidatorsService) {
  return {
    validationMessages: [
      {
        name: 'required',
        message() {
          return translate.stream('GENERIC.REQUIRED');
        },
      },
      {
        name: 'alphaNumeric',
        message() {
          return translate.stream('GENERIC.ALPHANUMERIC');
        },
      },
      {
        name: 'numeric',
        message() {
          return translate.stream('GENERIC.NUMERIC');
        },
      },
      {
        name: 'alphanumericandspecialchars',
        message() {
          return translate.stream('GENERIC.ALPHANUMERICANDSPECIALCHARS');
        },
      },
      {
        name: 'iban',
        message() {
          return translate.stream('GENERIC.INVALIDIBAN');
        },
      }
    ],
    validators: [
      { name: 'requiredTrue', validation: Validators.requiredTrue },
      { name: 'alphaNumeric', validation: AlphaNumericValidator },
      { name: 'alphanumericandspecialchars', validation: AlphaNumericAndSpecialCharsValidator },
      { name: 'numeric', validation: NumericValidator },
      { name: 'email', validation: EmailValidator },
      { name: 'date-future', validation: dateFutureValidator },
      { name: 'currency', validation: currencyValidator },
      {
        name: 'iban',
        validation: (control: FormControl) => {
          return AsyncIbanValidator(control, validatorsService);
        }
      }
    ]
  };
}